import type { ReceiptCategory, RouteMode } from '../types';

/** Stable order for category dropdowns */
export const RECEIPT_CATEGORY_OPTIONS: ReceiptCategory[] = [
  'food',
  'transport',
  'lodging',
  'flight',
  'train',
  'bus',
  'ferry',
  'other',
];

export const RECEIPT_CATEGORY_LABELS: Record<ReceiptCategory, string> = {
  food: 'Food',
  transport: 'Transport',
  lodging: 'Lodging',
  flight: 'Flight',
  train: 'Train',
  bus: 'Bus',
  ferry: 'Ferry',
  other: 'Other',
};

export const ROUTE_MODE_LABELS: Record<RouteMode, string> = {
  flight: 'Flight',
  train: 'Train',
  bus: 'Bus',
  ferry: 'Ferry',
  car: 'Car / drive',
  other: 'Other',
};
